export enum LocalStorageKeys {
  characters = "characters",
}
